// @flow
import React, { Component } from 'react'
import _ from 'lodash'
import styled, { type StyledComponent } from 'styled-components'
import RadioSelector from '../controls/RadioSelector'
import Button from '../controls/PrimaryButton'
import blueCheck from '../AudienceEdit/blue_check.png'
import Modal from '../FieldSet/Modal'
import LabeledWrapper from '../AudienceEdit/LabeledWrapper'
import FieldSet from '../FieldSet'

const Wrapper: StyledComponent<Object, any, any> = styled.div`
  display: flex;
`
const ProviderBlockWrapper: StyledComponent<Object, any, any> = styled.div`
  display: inline-block;
  width: 33%;
`
const Check: StyledComponent<Object, any, any> = styled.div`
  width: 21px;
  height: 21px;
  border: solid 1px #ccc;
  border-radius: 50%;
  top: 5px;
  left: 5px;
  display: inline-block;
`
const LabelWrapper: StyledComponent<Object, any, any> = styled.div`
  display: flex;
  padding-left: 10px;
`
const Label: StyledComponent<Object, any, any> = styled.div`
  font-size: 14px;
  padding-left: 10px;
  text-align: left;
  display: inline-block;
`
const StyledRadioSelector: StyledComponent<Object, any, any> = ((styled(RadioSelector).attrs({
  itemClass: 'item-class',
  selectedItemClass: 'selected-item-class'
}): any)`
  position: relative;
  left: -10px;

  .item-class {
    padding: 5px 0;
    position: relative;
    cursor: pointer;

    &.selected-item-class {
      ${Check} {
        background: transparent url(${blueCheck}) no-repeat -2px -1px;
      }
    }
  }
`: any)
const LocalGeoTypeWrapper: StyledComponent<Object, any, any> = styled.div`
  padding-top: 10px;
  padding-bottom: 10px;
`
const ProviderText: StyledComponent<Object, any, any> = styled.span`
  font-weight: bold;
`
const UsualOptions: StyledComponent<Object, any, any> = styled.div`
  padding-left: 30px;
`

type Props = {|
  vkLocalGeoType: string,
  tmLocalGeoVisitType: string,
  tmLocalGeoLocType: string,
  fbLocalGeoType: string,
  providers: Array<string>,
  onChange: Function
|}

type State = {|
  isModalOpen: boolean
|}

type ModalProps = {|
  vkLocalGeoType: string,
  tmLocalGeoVisitType: string,
  tmLocalGeoLocType: string,
  fbLocalGeoType: string,
  providers: Array<string>,
  onApply: Function
|}

type ModalState = {|
  vkLocalGeoType: string,
  tmLocalGeoVisitType: string,
  tmLocalGeoLocType: string,
  fbLocalGeoType: string
|}

export const t = {
  vk: 'ВКонтакте',
  facebook: 'Facebook',
  target_mail: 'myTarget',
  apply: 'Применить',
  local_geo_type: 'Тип мест',
  select_local_geo_type: 'Выбрать тип мест'
}

export const tVk = {
  regular: 'Регулярно бывает',
  home: 'Дом',
  work: 'Работа или учёба',
  online: 'Текущее местоположение'
}

export const tTm = {
  usual: 'Люди, регулярно бывающие там',
  now: 'Текущее местоположение',
  all: 'В любое время',
  home: 'В нерабочее время и праздники',
  work: 'В рабочее время'
}

export const tFb = {
  all: 'Все люди',
  recent: 'Недавние посетители',
  home: 'Местные жители',
  travel_in: 'Путешественники'
}

class ModalContent extends Component<ModalProps, ModalState> {
  constructor(props: ModalProps) {
    super(props)

    this.state = {
      vkLocalGeoType: props.vkLocalGeoType,
      tmLocalGeoVisitType: props.tmLocalGeoVisitType,
      tmLocalGeoLocType: props.tmLocalGeoLocType,
      fbLocalGeoType: props.fbLocalGeoType
    }
  }

  render() {
    const { vkLocalGeoType, tmLocalGeoVisitType, tmLocalGeoLocType, fbLocalGeoType } = this.state
    return (
      <div>
        <Wrapper>
          {this.renderVkBlock()}
          {this.renderTmBlock()}
          {this.renderFbBlock()}
        </Wrapper>
        <Button
          onClick={() =>
            this.props.onApply(
              vkLocalGeoType,
              tmLocalGeoVisitType,
              tmLocalGeoLocType,
              fbLocalGeoType
            )
          }
        >
          {t.apply}
        </Button>
      </div>
    )
  }

  renderVkBlock() {
    const { providers } = this.props
    const { vkLocalGeoType } = this.state

    if (!_.includes(providers, 'vk')) return null

    return (
      <ProviderBlockWrapper>
        <h2>{t.vk}</h2>
        <StyledRadioSelector
          radioOptions={this.vkOptions()}
          value={vkLocalGeoType}
          onChange={(vkLocalGeoType) => this.setState({ vkLocalGeoType })}
        />
      </ProviderBlockWrapper>
    )
  }

  renderTmBlock() {
    const { providers } = this.props
    const { tmLocalGeoVisitType, tmLocalGeoLocType } = this.state

    if (!_.includes(providers, 'target_mail')) return null

    return (
      <ProviderBlockWrapper>
        <h2>{t.target_mail}</h2>
        <StyledRadioSelector
          radioOptions={this.tmVisitTypeOptions()}
          value={tmLocalGeoVisitType}
          onChange={(tmLocalGeoVisitType) => {
            if (_.isEqual(tmLocalGeoVisitType, 'now')) this.setState({ tmLocalGeoLocType: 'all' })
            this.setState({ tmLocalGeoVisitType })
          }}
        />
        {_.isEqual(tmLocalGeoVisitType, 'usual') && (
          <UsualOptions>
            <StyledRadioSelector
              radioOptions={this.tmLocTypeOptions()}
              value={tmLocalGeoLocType}
              onChange={(tmLocalGeoLocType) => this.setState({ tmLocalGeoLocType })}
            />
          </UsualOptions>
        )}
      </ProviderBlockWrapper>
    )
  }

  renderFbBlock() {
    const { providers } = this.props
    const { fbLocalGeoType } = this.state

    if (!_.includes(providers, 'facebook')) return null

    return (
      <ProviderBlockWrapper>
        <h2>{t.facebook}</h2>
        <StyledRadioSelector
          radioOptions={this.fbOptions()}
          value={fbLocalGeoType}
          onChange={(fbLocalGeoType) => this.setState({ fbLocalGeoType })}
        />
      </ProviderBlockWrapper>
    )
  }

  vkOptions(): Array<{| value: string, renderer: any |}> {
    return [
      { value: 'regular', renderer: this.labelRenderer(tVk.regular) },
      { value: 'home', renderer: this.labelRenderer(tVk.home) },
      { value: 'work', renderer: this.labelRenderer(tVk.work) },
      { value: 'online', renderer: this.labelRenderer(tVk.online) }
    ]
  }

  tmVisitTypeOptions(): Array<{| value: string, renderer: any |}> {
    return [
      { value: 'now', renderer: this.labelRenderer(tTm.now) },
      { value: 'usual', renderer: this.labelRenderer(tTm.usual) }
    ]
  }

  tmLocTypeOptions(): Array<{| value: string, renderer: any |}> {
    return [
      { value: 'all', renderer: this.labelRenderer(tTm.all) },
      { value: 'home', renderer: this.labelRenderer(tTm.home) },
      { value: 'work', renderer: this.labelRenderer(tTm.work) }
    ]
  }

  fbOptions(): Array<{| value: string, renderer: any |}> {
    return [
      { value: 'all', renderer: this.labelRenderer(tFb.all) },
      { value: 'home', renderer: this.labelRenderer(tFb.home) },
      { value: 'recent', renderer: this.labelRenderer(tFb.recent) },
      { value: 'travel_in', renderer: this.labelRenderer(tFb.travel_in) }
    ]
  }

  labelRenderer(label: string) {
    return (
      <LabelWrapper>
        <Check />
        <Label className="t-MicroLocationsType">{label}</Label>
      </LabelWrapper>
    )
  }
}

export default class LocalGeoType extends Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      isModalOpen: false
    }
  }

  render() {
    const {
      vkLocalGeoType,
      tmLocalGeoVisitType,
      tmLocalGeoLocType,
      fbLocalGeoType,
      providers,
      onChange
    } = this.props
    return (
      <div>
        <Modal
          maxWidth={800}
          header={t.select_local_geo_type}
          isOpen={this.state.isModalOpen}
          hideBtn
          onClose={() => this.setState({ isModalOpen: false })}
        >
          <ModalContent
            vkLocalGeoType={vkLocalGeoType}
            tmLocalGeoVisitType={tmLocalGeoVisitType}
            tmLocalGeoLocType={tmLocalGeoLocType}
            fbLocalGeoType={fbLocalGeoType}
            providers={providers}
            onApply={(vkLocalGeoType, tmLocalGeoVisitType, tmLocalGeoLocType, fbLocalGeoType) => {
              this.setState({ isModalOpen: false })
              onChange({ vkLocalGeoType, tmLocalGeoVisitType, tmLocalGeoLocType, fbLocalGeoType })
            }}
          />
        </Modal>
        <LabeledWrapper label={t.local_geo_type}>
          <LocalGeoTypeWrapper>
            {_.includes(providers, 'vk') && (
              <div className="t-MicroLocationsTypeText">
                <ProviderText>{`${t.vk}:`}</ProviderText> <span>{tVk[vkLocalGeoType]}</span>
              </div>
            )}
            {_.includes(providers, 'target_mail') && (
              <div className="t-MicroLocationsTypeText">
                <ProviderText>{`${t.target_mail}:`}</ProviderText>{' '}
                <span>{`${tTm[tmLocalGeoVisitType]}, ${tTm[tmLocalGeoLocType]}`}</span>
              </div>
            )}
            {_.includes(providers, 'facebook') && (
              <div className="t-MicroLocationsTypeText">
                <ProviderText>{`${t.facebook}:`}</ProviderText> <span>{tFb[fbLocalGeoType]}</span>
              </div>
            )}
          </LocalGeoTypeWrapper>
          <FieldSet.OpenButton
            label={t.select_local_geo_type}
            onClick={() => this.setState({ isModalOpen: true })}
          />
        </LabeledWrapper>
      </div>
    )
  }
}
